// 選択中ファイルの一括AI解析実行 (未投入は新規投入、解析済み・失敗済みは再解析)
import { computed, ref } from 'vue';

// サーバー側 AiReanalysisPolicy::REANALYZABLE (analyzed / failed / analyzing) と同じ
const REANALYZABLE_STATUSES = ['analyzed', 'failed', 'analyzing'];
// サーバーは token_limit_exceeded を新規投入として扱う (AiReanalysisService::classify)
const NEW_STATUSES = ['', 'token_limit_exceeded'];

export const useBulkAiAnalysis = (basketCount, clearBasket, basketFileItemsList) => {
  // 再解析の確認チェック (再解析対象が 1 件以上あるときに必須)
  const reanalyzeConfirmed = ref(false);

  const bulkAiStatusOf = (item) => {
    const status = item && item.aiAnalysisStatus ? String(item.aiAnalysisStatus) : '';
    if (NEW_STATUSES.includes(status)) return 'none';
    // 画面の表示は analyzed / failed / in_flight / none の 4 種。analyzing は処理中の表示にする (数えるのは再解析側)。
    if (status === 'analyzing') return 'in_flight';
    if (REANALYZABLE_STATUSES.includes(status)) return status;
    return 'in_flight';
  };

  const bulkAiReanalyzeCount = computed(() =>
    (basketFileItemsList.value || []).filter((item) => REANALYZABLE_STATUSES.includes(String(item.aiAnalysisStatus || ''))).length
  );

  const bulkAiNewCount = computed(() =>
    (basketFileItemsList.value || []).filter((item) => NEW_STATUSES.includes(String(item.aiAnalysisStatus || ''))).length
  );

  const bulkAiCanSubmit = computed(() =>
    basketCount.value >= 1 && (bulkAiReanalyzeCount.value === 0 || reanalyzeConfirmed.value)
  );

  const showBulkAiAnalysisModal = () => {
    if (basketCount.value < 1) return;
    reanalyzeConfirmed.value = false;
    if (window.jQuery) {
      window.jQuery('#bulkAiAnalysisModal').modal('show');
    }
  };

  const submitBulkAiAnalysis = () => {
    if (!bulkAiCanSubmit.value) return;
    const form = document.getElementById('bulkAiAnalysisForm');
    if (!form) return;
    if (window.jQuery) {
      window.jQuery('#bulkAiAnalysisModal').modal('hide');
    }
    form.submit();
    clearBasket();
  };

  return {
    showBulkAiAnalysisModal,
    submitBulkAiAnalysis,
    reanalyzeConfirmed,
    bulkAiStatusOf,
    bulkAiReanalyzeCount,
    bulkAiNewCount,
    bulkAiCanSubmit,
  };
};
